import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { AppConfig } from '../../app.config';

@Component({
  selector: 'app-managesop',
  templateUrl: './manageSop.component.html',
  styleUrls: ['./manageSop.component.css']
})
export class ManageSopComponent implements OnInit {

  sopId: number;
  versionNo: number;
  viewType: 'view' | 'edit';
  constructor(private activatedRoute: ActivatedRoute, private router: Router, public appConfig: AppConfig) { }

  ngOnInit() {
    this.sopId = +this.activatedRoute.snapshot.params.sopId;
    this.versionNo = +this.activatedRoute.snapshot.params.versionNo;
    this.viewType = this.activatedRoute.snapshot.params.viewType;
  }

  childData(data) {
    var roleId = this.appConfig.userData.roleName.roleId;
    switch (data.key) {
      case 'save':
      case 'cancel':
        if (roleId == 5 || roleId == 4) {
          this.router.navigate(['/sopObserve/sopEditor']);
        } else {
          this.router.navigate(['/sop']);
        }
        break;
    }
  }

}
